import OriginalAxios from "axios";

import { apiForFormBuilder } from "../config";

export const axiosForFormBuilder = OriginalAxios.create({
 baseURL: apiForFormBuilder,
});
